<template>
  <v-dialog
    v-model="isReceivingSetting"
    width="380px"
    :before-close="close"
    :modal-append-to-body="false"
    @click:outside="close"
  >
    <!-- <v-row no-gutters style="background-color: #21343b; justify-content: space-between" class="px-4 py-5">
      <span class="txt-dialog-title ml-2">{{ $t('receivingSettingTitle') }}</span>
      <v-btn dark elevation="0" icon @click="close">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-row> -->
    <v-row
      no-gutters
      dense
      justify="space-between"
      v-if="currentClip && currentClip !== null && currentClip.length !== 0"
      style="background-color: #21343b; margin: 0 !important; font-size: 15px"
      class="px-6 pt-2"
    >
      <v-col align-self="center" cols="auto">
        <span style="font-size: 17px; color: #eee; font-weight: 700">{{ 'Receive messages' }}</span>
      </v-col>
      <v-col cols="auto">
        <v-switch
          v-model="isEnable"
          color="#13ce66"
          @click="updateChannel"
          :loading="isLoading"
          :disabled="isLoading"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row no-gutters style="background-color: #21343b; font-size: 14px" class="px-4">
      <span style="color: #96a7af" class="ml-2">
        {{
          'Share the link to this channel, allowing people to submit video messages. They will ONLY be able to view and access the conversations they initiate.'
        }}
      </span>
    </v-row>
    <!-- <v-row no-gutters style="background-color: #21343b; margin: 0 !important" class="px-6 py-0">
      <v-col cols="12">
        <v-textarea solo dark dense flat no-resize rows="1" row-height="15" :label="showPath" disabled></v-textarea>
      </v-col>
    </v-row> -->
    <v-row no-gutters justify="space-between" style="background-color: #21343b; margin: 0 !important" class="px-6 pb-7">
      <v-col class="container-copy-url mt-5" cols="12" align="center">
        <v-btn class="btn-copy-url" color="rgb(40, 144, 103)" width="100%" @click="copyUrlToClipboard" dark>
          {{ 'Copy Link' }}
        </v-btn>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { copy } from '@/common/common'
import { isMobile, isSafari } from '@/common/lib/strLib'
import { getShareUrl, setUserFunnel } from '@/services/api'
import { setPublicMt } from '@/services/meetingApi'
import { mapGetters } from 'vuex'
import { setChannelDetail } from '@/services/channelApi'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'ShareDialog',
  props: { isReceivingSetting: Boolean },
  data() {
    return {
      path: '',
      isEnable: false,
      safariPath: null,
      safariPathWithClipId: null,
      isLoading: false,
      showPath: window.location.href,
    }
  },
  created() {
    if (this.isSafari) this.setSafariUrl()
    this.isEnable = this.computedSelectedCh.receivingStatus === 'on'
  },
  methods: {
    async updateChannel() {
      try {
        this.isLoading = true
        let result = await setChannelDetail(
          this,
          this.userInfo.userId,
          this.selectedWsInfo.wsId,
          this.selectedCh.chType,
          this.selectedCh.chId,
          this.computedSelectedCh.chTitle,
          this.computedSelectedCh.chDescription,
          this.isEnable ? 'on' : 'off',
          this.selectedCh.chLogo
        )
        this.computedSelectedCh.receivingStatus = result.receivingStatus
      } catch (error) {
        console.log('error ', error)
      } finally {
        this.isLoading = false
      }
    },
    async setSafariUrl() {
      let title = this.selectedCh.chTitle
      let content = ''
      let imgUrl = this.selectedCh.chLogo
      let routePayload = {
        name: 'Channel',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href

      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.safariPath = copyUrl.shortLink
      this.safariPathWithClipId = copyUrl.shortLink
    },
    async copyUrlToClipboard() {
      let copyResult
      let safariUrl = this.clipValue ? this.safariPathWithClipId : this.safariPath
      if (this.isSafari && this.safariUrl !== null) {
        copyResult = await copy(safariUrl)
      } else {
        // Short Link 제거
        // await this.createShareUrl()
        // copyResult = await copy(this.path)

        copyResult = await copy(location.href)
      }

      if (copyResult) {
        this.checkFunnel()
        this.$store.dispatch('setFirebaseLog', {
          eventName: 'share',
          eventParam: {
            name: 'share',
            methodType: this.clipValue ? 'clip' : 'meeting',
          },
        })
        if (!this.isMobile) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
    async checkFunnel() {
      if (this.userInfo !== null) {
        try {
          const funnel = this.userInfo.funnel
          if (!funnel || funnel === '' || funnel === 'evaluator') {
            let result = await setUserFunnel(this, 'beginner')
            this.$store.commit('setUserInfo', result)

            this.$store.dispatch('setFirebaseLog', {
              eventName: 'funnel_beginner',
              eventParam: {
                createdAt: Date.now(),
                methodType: 'share_meeting',
              },
            })
          }
        } catch (e) {
          console.log()
        }
      }
    },
    async createShareUrl() {
      let title = this.selectedCh.chTitle
      let content = ''
      let imgUrl = this.selectedCh.chLogo
      let routePayload = {
        name: 'Channel',
        params: {
          wsDomain: this.$route.params['wsDomain'],
          chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
        },
      }
      let linkUrl = location.origin + this.$router.resolve(routePayload).href

      let copyUrl = await getShareUrl(this, title, content, imgUrl, linkUrl)
      this.path = copyUrl.shortLink
    },
    async setPublicMt() {
      try {
        await this.$store.dispatch('setIsLoading', true)
        await setPublicMt(this, this.selectedWsInfo.wsId, this.currentMt.mtId, '*', this.currentMt.isPublic)
      } catch (error) {
        console.log(error)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
      }
    },
    close() {
      this.$emit('close', 'Receiving')
    },
  },
  computed: {
    ...mapGetters([
      'selectedWsInfo',
      'selectedCh',
      'currentMt',
      'currentClip',
      'userInfo',
      'isMtOrganizer',
      'isWsManager',
      'isWsOwner',
    ]),
    isMobile() {
      return isMobile()
    },
    isSafari() {
      return isSafari()
    },
    computedSelectedCh() {
      return this.selectedCh ?? {}
    },
  },
}
</script>

<style scoped>
.txt-dialog-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.container-copy-url >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.v-textarea >>> label {
  font-size: 13px !important;
}
</style>
